import { createSelector } from 'reselect';

import initialState from './initialState';
import reducer from './reducer';

export type RootState = ReturnType<typeof reducer>;
const selectRoot = (state: RootState) => state || initialState;

const createInitialSelectors = () => {
  let selectors: Record<string, any> = {};
  Object.keys(initialState).map((key) => {
    selectors[key] = createSelector(
      selectRoot,
      (state: RootState) => state[key as keyof RootState]
    );
  });

  return selectors;
};

const selectors: ReturnType<typeof createInitialSelectors> =
  createInitialSelectors();
export default selectors;
